export default __webpack_public_path__ + "static/media/freeShipping.f5b512a3.svg";